import { useState } from 'react';

function ImageWithRetry({ src, fallback = '/images/fallback.jpeg', alt = 'image' }) {
  const [imageSrc, setImageSrc] = useState(src);
  const [attempt, setAttempt] = useState(0);

  const handleError = () => {
    if (attempt < 2) {
      setAttempt((prevAttempt) => prevAttempt + 1);
      setImageSrc(src + `?retry=${attempt + 1}`);
    } else {
      setImageSrc(fallback);
    }
  };

  return <img alt={alt} src={imageSrc} className="w-full h-full object-cover" onError={handleError} />;
}

export default ImageWithRetry;
